import { render, staticRenderFns } from "./AttributesListsCard.vue?vue&type=template&id=19a6d003"
import script from "./AttributesListsCard.vue?vue&type=script&lang=js"
export * from "./AttributesListsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports